import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { text } = theme.palette;

  return {
    tableRow: {
      display: "grid",
      gridTemplateColumns: "40% 60%",
      minHeight: 32,
      padding: "7px 12px",
      fontSize: 12,
      color: text.primary,
      border: "1px solid #eee",
      borderBottom: "none",
      "&:first-child": {
        borderTop: "1px solid #eee"
      },
      "&:last-child": {
        borderBottom: "1px solid #eee"
      },
      "&:nth-child(even)": {
        backgroundColor: "#f7f7f7"
      }
    },
    cell: {
      display: "flex",
      alignItems: "center"
    },
    label: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    value: {
      wordBreak: "break-word",
      lineHeight: "normal"
    },
    united: {
      gridTemplateColumns: "1fr",
      padding: "0 12px 14px",
      "& $label": {
        height: 32
      }
    }
  };
});
